
import * as ipxRuntime$_345fYyRa6Zo_s2Ri6OMFOR8BO_jkfRR8PbMoofdEODs from '/home/runner/work/nuxt.com/nuxt.com/node_modules/.pnpm/@nuxt+image@https+++pkg.pr.new+@nuxt+image@1a5786c_@netlify+blobs@9.1.2_db0@0.3.2_bette_9a6ae36280e5c1c7a3f04827f62d8c1d/node_modules/@nuxt/image/dist/runtime/providers/ipx'
import * as noneRuntime$z8pYoVczE7YHMZht_45wBWztXbU1FhNVq1ZS_45Inns0qpY from '/home/runner/work/nuxt.com/nuxt.com/node_modules/.pnpm/@nuxt+image@https+++pkg.pr.new+@nuxt+image@1a5786c_@netlify+blobs@9.1.2_db0@0.3.2_bette_9a6ae36280e5c1c7a3f04827f62d8c1d/node_modules/@nuxt/image/dist/runtime/providers/none'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "none",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "jpeg",
    "jpg",
    "png",
    "svg",
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$_345fYyRa6Zo_s2Ri6OMFOR8BO_jkfRR8PbMoofdEODs, defaults: {"baseURL":"https://ipx.nuxt.com"} },
  ['none']: { provider: noneRuntime$z8pYoVczE7YHMZht_45wBWztXbU1FhNVq1ZS_45Inns0qpY, defaults: {} }
}
        